// 映射及计算

export const menuArr = state => state.menuArr

export const currentMenu = state => state.currentMenu

export const currentPosition = state => state.currentPosition

export const queryCondition = state => state.queryCondition

export const conditionDesc = state => state.conditionDesc

export const mkeyDescription = state => state.mkeyDescription

export const reportBaseUrl = state => state.reportBaseUrl



// WEBPACK FOOTER //
// ./src/store/getters.js